import React from "react";
import { cn } from "@/lib/utils";

interface PartnerMetricCardProps {
  label: string;
  value: React.ReactNode;
  hint?: string;
  icon: React.ReactNode;
  tone?: "blue" | "violet" | "amber" | "emerald" | "slate";
}

const toneClasses = {
  blue: "bg-sky-50 text-sky-700",
  violet: "bg-violet-50 text-violet-700",
  amber: "bg-amber-50 text-amber-700",
  emerald: "bg-emerald-50 text-emerald-700",
  slate: "bg-slate-100 text-slate-700",
};

const PartnerMetricCard: React.FC<PartnerMetricCardProps> = ({
  label,
  value,
  hint,
  icon,
  tone = "blue",
}) => (
  <div className="rounded-2xl border border-slate-200 bg-white p-4 sm:p-5">
    <div className="flex items-start justify-between gap-3">
      <div className="min-w-0">
        <p className="text-xs font-semibold uppercase tracking-[0.08em] text-slate-500">
          {label}
        </p>
        <p className="mt-2 text-2xl font-bold tracking-tight text-slate-950 sm:text-3xl">
          {value}
        </p>
        {hint && <p className="mt-1 text-xs leading-5 text-slate-500">{hint}</p>}
      </div>
      <div className={cn("flex h-10 w-10 shrink-0 items-center justify-center rounded-xl", toneClasses[tone])}>
        {icon}
      </div>
    </div>
  </div>
);

export default PartnerMetricCard;
